module.exports = __webpack_public_path__ + "static/media/sorting_default_icon.38ac4cf2.svg";